import { Component } from '@angular/core';

@Component({
  selector: 'tun-help20px-icon-v5',
  templateUrl: './help20px-icon-v5.component.html',
  styleUrls: ['./help20px-icon-v5.component.scss']
})
export class Help20pxIconV5Component {

}
